/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { obsView } from './obsView.js';
import { mapObject } from './utils.js';

/**
 * Creates a React component with typed observable props.
 * Props are transformed according to their IPropertyTransformerFactory.
 */
function view(props, render) {
    return obsView('view', (p) => {
        const readableProps = mapObject(props, (value, key) => {
            return value.create(reader => p.read(reader)[key], undefined);
        });
        return reader => {
            const propValues = mapObject(readableProps, (value) => {
                return value.read(reader);
            });
            return render(reader, propValues);
        };
    });
}

export { view };
//# sourceMappingURL=view.js.map
